/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Clear_SearchInputs */

const en_read_along_clear_search = /** @type {(inputs: Read_Along_Clear_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear search`)
};

const es_read_along_clear_search = /** @type {(inputs: Read_Along_Clear_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar búsqueda`)
};

/**
* | output |
* | --- |
* | "Clear search" |
*
* @param {Read_Along_Clear_SearchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_clear_search = /** @type {((inputs?: Read_Along_Clear_SearchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Clear_SearchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_clear_search(inputs)
	return en_read_along_clear_search(inputs)
});